import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import PulsePage from "./pages/pulse/PulsePage";
import PulsePublicMediaKit from "./pages/pulse/PulsePublicMediaKit";
import LoginPage from "./pages/auth/LoginPage";
import MagicLoginPage from "./pages/auth/MagicLoginPage";
import AuthGate from "./pages/auth/AuthGate";
import { isAuthenticated } from "./lib/authApi";

const LoginRoute: React.FC = () => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LoginPage />;
};

const appTheme = createTheme({
  typography: {
    fontFamily: '"Geist", "Inter", "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  palette: {
    mode: "dark",
    background: {
      default: "#050714",
      paper: "#0A1124",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: "100%",
          minHeight: "100%",
          backgroundColor: "#050714",
        },
        body: {
          height: "100%",
          minHeight: "100%",
          backgroundColor: "#050714",
        },
        "#root": {
          height: "100%",
          minHeight: "100%",
          backgroundColor: "#050714",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <BrowserRouter>
        <CssBaseline />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/magic-login" element={<MagicLoginPage />} />
          <Route path="/mk/:handle/share/:slug" element={<PulsePublicMediaKit />} />
          {["/dashboard", "/insights", "/pulse-score", "/media-kit", "/bookmarks", "/settings"].map((path) => (
            <Route
              key={path}
              path={path}
              element={
                <AuthGate>
                  <PulsePage />
                </AuthGate>
              }
            />
          ))}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
